import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { getReportList, getSingleReport } from '../apiCalls.js';
import { StoreContext } from '../Store';
import DataTable from './DataTable1';
import { postSelectedReport } from '../apiCalls';
import { Downloadxls } from './Downloadxls.js';

const ReportsList = () => {
  const store = useContext(StoreContext);
  const navigate = useNavigate();
  const inputStyle = { width: '90%', boxSizing: 'border-box', border: 'none', backgroundColor: 'transparent' };
  // Default Header Styles
  const headerStyle = { fontSize: '12px' };
  // Default Row Styles
  const defaultStyle = { fontSize: '14px', width: '2rem' };
  const buttonStyle = { backgroundColor: 'transparent', border: 'none', height: '4rem', width: '4rem' };
  const imageStyle = { height: '1rem', width: '1rem', marginRight: '8px' };
  // Override individual row styles

  const storeReports = (data) => {
    store.reportOptions[1](data);
  };

  const handleSubmit = (event) => {
    store.reportSelected[1](event.id);
    const reportName = event.name;
    getSingleReport('report', event.id).then(async (data) => {
      store.reportParams[1](data);
      if (event.button === 'download') {
        const result = await postSelectedReport(data[0].endPoint, new FormData());
        Downloadxls(result, reportName);
      } else if (data[0].parameters === '') {
        navigate(`/ReportsResults/${data[0].endPoint}/${data[0].data}/4`);
      } else {
        navigate(`/ReportsAdmin/${reportName}`);
      }
    });
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const replist = await getReportList();
        storeReports(replist);
      } catch (err) {
        console.log(err);
      }
    }
    fetchData();
  }, []);

  return (
    <Container className="full-width-container">
      <section className="floating-box" style={{ minWidth: '800px' }}>
        <div className="d-flex flex-row justify-content-between">
          <h1 className="floating-box-header-general">Reports</h1>
        </div>
        <div className="px-3 pt-4">
          <DataTable
            initialData={store.reportOptions[0]}
            disabled={true}
            defaultStyle={defaultStyle}
            headerStyle={headerStyle}
            sortable={true}
            filterable={true}
            inputStyle={inputStyle}
            rootClose={true}
            downloadable={false}
            buttonDisabled={false}
            buttonStyle={buttonStyle}
            imageStyle={imageStyle}
            buttonOnClick={handleSubmit}
            showMagGlass={true} //show the mag glass for the Reports page
          />
        </div>
      </section>
    </Container>
  );
};

export default ReportsList;
